module.exports = __webpack_public_path__ + "img/svg.482173e.svg";